module.exports = __webpack_public_path__ + "img/OSL.ad783b3b.png";